import { Injectable } from '@angular/core'
import * as AWS from 'aws-sdk'

@Injectable()
export class AWSService {
	constructor() {
		AWS.config.update({
			region: 'us-east-1',
			accessKeyId: 'AKIASI7MP7LZNLTARXCR',
			secretAccessKey: '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'
		})
	 }

	public async uploadToS3(file: any, bucketName = 'arbolink-app'): Promise<any> {
		const S3: AWS.S3 = new AWS.S3()
		const timestamp = new Date().getTime()
		const random = Math.random().toString(36).substring(2, 7)
		const fileName = `${timestamp}_${random}_${file.name}`
		const uploadPromise: Promise<AWS.S3.ManagedUpload.SendData> = S3.upload(
			{
				Key: fileName,
				Bucket: bucketName,
				Body: file,
				ACL: 'public-read'
			}
		).promise()

		return uploadPromise
	}

	public sendListPromise(list: Array<any>): Promise<any> {
		return new Promise(async (resolve, reject) => {
			const gallery: Array<any> = []
			list.forEach(item => {
				gallery.push(this.uploadToS3(item.file))
			})

			resolve(await Promise.all(gallery))
		})
	}
}
